import './App.scss';

import { store,persistor } from './configureStore';
import Footer from './Component/Footer/Footer';
// import Header from './Component/Header/Header';

import Nav from './navigation/Nav';
import { TimeoutLogic } from "./../src/utils/TimeoutLogic";
import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function App() {

  return (

    <main>
{/* <Header /> */}
    <Provider store={store} >

    <PersistGate  persistor={persistor}>

          <Nav/>
          <TimeoutLogic/> 

       </PersistGate>

    </Provider>
    <Footer />
    <ToastContainer 
     position="top-right"
     autoClose={5000}
     hideProgressBar={false}
     closeOnClick={true}
     pauseOnHover
     draggable
     closeButton={true} />
    </main>

  );

}



export default App;